// IMPORTS
import _ from 'lodash'
import axios from 'axios'

// DEFINITIONS
const loginApi = 'account/trylogin'

const state = {
    reportes_compras_id: null,
    elementos: [],
    pedidosInvolucrados: []
}

const getters = {
    reporteComprasGetID: (state) => {return state.reportes_compras_id},
    reporteComprasGetElementos: (state) => { return state.elementos },
    reporteComprasGetElementosForMobiscroll: (state) => { return _.map(state.elementos, (item) => {
            return  {
                value: item.id,
                text: `${item.elemento} ${item.presentacion} ${item.unidadmedicion} ${item.marca}`,
                group: `${item.categoria} - ${item.grupo}`
            }
        })
    },
    reporteComprasGetPedidosInvolucradosForMobiscroll: (state) => { return _.map(state.pedidosInvolucrados, (item) => {
            return  {
                value: item.elemento_id_pk,
                text:  `${item.elemento} ${item.marca} ${item.tipo_presentacion} ${item.presentacion} ${item.unidadmedicion}`,
                group: _.toUpper(`Folio ${item.folio} - ${item.nombre} ${item.apellidos}`)
            }
        })
    },
    reporteComprasGetPedidosInvolucrados: (state) => { return state.pedidosInvolucrados }
}

const mutations = {
    reporteComprasSetLocalData: (state, payload) => {
        console.log('payload', payload)
        // Procede solo con Payload
        if(payload != null && typeof payload != 'object') return
        
        // Define el ID de reportes de compras, para numerico o null, (Si fuere a llegar el caso)
        if(payload.reportes_compras_id)
            state.reportes_compras_id               = payload.reportes_compras_id
        else
            state.reportes_compras_id               = null
        
        // Define los elementos
        if(payload.reportesCompras && payload.reportesCompras.length)
            state.elementos                         = payload.reportesCompras
        
        // define los pedidos involucrados
        if(payload.pedidosInvolucrados && payload.pedidosInvolucrados.length)
            state.pedidosInvolucrados               = payload.pedidosInvolucrados
    }
}

const actions = {
	
}

// EXPORTS
export default {
	state,
	getters,
	mutations,
	actions
};
